// Central design tokens for the salon-tool UI revamp.
// Import these instead of hard-coding hex/radius/shadow values so the look
// stays consistent across every page.

export const brand = {
  // Core
  gold: '#C7A46E',
  goldDark: '#A88755',
  goldLight: '#DBC4A4',
  goldSoft: '#F3EADB', // very light gold wash for subtle backgrounds
  ink: '#232122', // near-black primary text
  inkSoft: '#6C757D', // secondary text
  cream: '#F5F1EF', // app background
  creamDark: '#E5E0DD',
  white: '#FFFFFF',
  // Accents (muted, work with gold)
  sage: '#8BA888',
  mauve: '#9E8B8E',
  rust: '#D4846F',
  navy: '#2D4654',
  // Feedback
  success: '#3B9B6B',
  successSoft: '#E5F4EC',
  warning: '#E0A64B',
  warningSoft: '#FBF0DC',
  danger: '#D0605A',
  dangerSoft: '#FBE9E8',
  info: '#4A90E2',
  infoSoft: '#E8F1FB',
  // Lines
  border: '#ECE7E1',
} as const;

// Corner radii
export const radius = {
  sm: 8,
  md: 12,
  lg: 16,
  xl: 22,
  pill: 999,
} as const;

// Soft, warm-tinted elevation (avoids the harsh grey MUI defaults)
export const shadow = {
  xs: '0 1px 2px rgba(35, 33, 34, 0.04)',
  sm: '0 2px 8px rgba(35, 33, 34, 0.06)',
  md: '0 6px 20px rgba(35, 33, 34, 0.08)',
  lg: '0 14px 40px rgba(35, 33, 34, 0.12)',
  gold: '0 8px 24px rgba(199, 164, 110, 0.28)',
} as const;

// Gradients used for hero cards / accents
export const gradient = {
  gold: 'linear-gradient(135deg, #DBC4A4 0%, #C7A46E 60%, #A88755 100%)',
  ink: 'linear-gradient(135deg, #232122 0%, #4D4A4B 100%)',
  cream: 'linear-gradient(135deg, #FAF7F6 0%, #F3EADB 100%)',
} as const;

// Minimum comfortable touch target (px)
export const touchTarget = 44;
